import React, { useState, createContext, useContext, useEffect } from "react";
import { useHistory  } from "react-router-dom";

export const AuthContext = createContext({
  isLoggedIn: false,
  user: null,
  login: () => {},
  logout: () => {},
  setUser: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const { navigate } = useHistory();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 컴포넌트 마운트 시 세션 스토리지에서 사용자 정보 확인
  useEffect(() => {
    const checkLoginStatus = () => {
      try {
        // 먼저 sessionStorage 확인 (현재 세션)
        let storedUser = sessionStorage.getItem("user");
        
        // sessionStorage에 없으면 localStorage 확인 (이전 세션)
        if (!storedUser) {
          storedUser = localStorage.getItem("user");
          // localStorage에서 복원된 경우 sessionStorage에도 저장
          if (storedUser) {
            sessionStorage.setItem("user", storedUser);
          }
        }
        
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          setUser(userData);
          setIsLoggedIn(true);
          console.log('자동 로그인 성공');
        }
      } catch (error) {
        console.error('로그인 상태 확인 중 오류 발생:', error);
        localStorage.removeItem("user");
        sessionStorage.removeItem("user");
        setUser(null);
        setIsLoggedIn(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkLoginStatus();
  }, []);

  const login = async (userData) => {
    // 두 저장소에 모두 저장
    localStorage.setItem("user", JSON.stringify(userData));
    sessionStorage.setItem("user", JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
  };
  const logout = async () => {
    // 두 저장소에서 모두 제거
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    setIsLoggedIn(false);
    setUser(null);
    navigate("/");
  };

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, user, login, logout, setIsLoggedIn, setUser, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};